// import React, {useEffect, useState, useRef, useMemo} from "react";
// import refreshIcon from "../resourse/icons/refreshColor.svg";
// import {useNavigate, useLocation} from "react-router-dom";
// import {sendLog} from "../functions/common/SendLog";
// import CheckBox from "../Components/CheckBox";
// import {Button, Modal} from "react-bootstrap";
// import MyModal from "../Components/MyModal";
// import {ServerApi} from "../api/ServerApi";
//
// //Стили
// import "./style/documents.css";
// import "./style/palette.css";
// import "./style/common.css";
//
// //Страница №4
// //Список документов для предварительного просмотра. Модальное окно для кода подтверждения.
// export default function DocumentsPage() {
//     const [disDataReason, setDisDataReason] = useState('Эта информация будет отсутствовать в договоре');
//     const [warning, setWarning] = useState({data: '', bool: false});
//     const [documentsForSign, setDocumentsForSign] = useState([]);
//     const [previewImagesState, setPreviewState] = useState([]);
//     const [disDataModal, setDisDataModal] = useState(false);
//     const [disDataAction, setDisDataAction] = useState('1'); //?
//     const [errorSuccess, setErrorSuccess] = useState(false);
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [isDisabled, setIsDisabled] = useState(true);
//     const [modalOpen, setModalOpen] = useState(false);
//     const [isChecked, setIsChecked] = useState(false);
//     const [opacity, setOpacity] = useState('header');
//     const [checked, setChecked] = useState(false);
//     const [userName, setUserName] = useState("");
//     const [timeLeft, setTimeLeft] = useState(60);
//     const [disData, setDisData] = useState([]);
//     const [timer, setTimer] = useState(false);
//     const [error, setError] = useState([]);
//
//     const hasFetched = useRef(false);
//     const navigate = useNavigate();
//     const location = useLocation();
//
//     const title = 'Страница 4. Список документов для предварительного просмотра.';
//     const serverApi = useMemo(() => new ServerApi(), []);
//
//     const handleCheckboxChange = () => {
//         setIsChecked((prevState) => !prevState);
//         setIsDisabled(!isDisabled);
//     };
//
//     const disDataClick = (action) => {
//         if (action == '1') {
//             setDisDataModal(false);
//         } else {
//             localStorage.clear();
//             navigate('/');
//         }
//     };
//
//     const click = () => {
//         setIsModalOpen(false);
//         setTimer(true);
//         setTimeLeft(60);
//     };
//
//     const handleContinueClick = () => {
//         const docSessionCode = localStorage.getItem("doc_session_code");
//         const appDebag = localStorage.getItem("app_debag");
//
//         serverApi.setCode(docSessionCode, appDebag).then((response) => {
//             sendLog(serverApi, title, 'Отправка SMS с кодом клиенту.', 'setCode', false, response);
//             if (response.data.success) {
//                 setIsModalOpen(true);
//             } else {
//                 const errorData = response?.data?.error;
//                 const errorMessages = Array.isArray(errorData) ? errorData :
//                     (errorData ? [String(errorData), 'Попробуйте снова'] : ['Не удалось отправить SMS', 'Попробуйте снова']);
//
//                 setError(errorMessages);
//                 setErrorSuccess(true);
//                 sendLog(serverApi, title, 'Ошибка отправки SMS.', 'setCode', true, response);
//             }
//         }).catch((error) => {
//             setError(['Ошибка соединения', 'Проверьте интернет']);
//             setErrorSuccess(true);
//             sendLog(serverApi, title, 'Сетевая ошибка при отправке SMS.', 'setCode', true, error);
//         });
//     };
//
//     useEffect(() => {
//         if (location.state?.errorCode === 'wrong_code') {
//             setError(['Неверный код подтверждения', 'Попробуйте снова']);
//             setErrorSuccess(true);
//         } else if (location.state?.errorCode === 'network_error') {
//             setError(['Ошибка соединения', 'Проверьте интернет и попробуйте снова']);
//             setErrorSuccess(true);
//         }
//         if (location.state) {
//             window.history.replaceState({}, document.title);
//         }
//     }, [location]);
//
//     useEffect(() => {
//         if (hasFetched.current) return;
//         hasFetched.current = true;
//
//         const docSessionCode = localStorage.getItem("doc_session_code");
//         const appDebag = localStorage.getItem("app_debag");
//         setOpacity('header2');
//         setModalOpen(true);
//
//         serverApi.getDocumentList(docSessionCode, appDebag).then((response) => {
//             if (response.status === 500) {
//                 setChecked(false);
//                 setError(['Сервис временно не доступен']);
//                 setErrorSuccess(true);
//                 setModalOpen(false);
//                 sendLog(serverApi, title, 'Сервис временно не доступен', 'getDocumentList', true, response);
//
//             } else if (response.status === 501) {
//                 setChecked(false);
//                 setError(['Нет документов на подпись', 'Свяжитесь с Вашим оператором']);
//                 setErrorSuccess(true);
//                 setModalOpen(false);
//                 sendLog(serverApi, title, 'Нет документов на подпись', 'getDocumentList', true, response);
//
//             } else if (response.status === 200) {
//                 if (response?.data?.success) {
//                     const fio = response.data.username
//                     setUserName(fio);
//                     localStorage.setItem('username', fio);
//
//                     const rawDocs = response.data.data;
//                     let docsList = [];
//
//                     if (rawDocs && typeof rawDocs === 'object' && !Array.isArray(rawDocs)) {
//                         docsList = Object.entries(rawDocs).map(([upload_id, doc]) => ({
//                             upload_id,
//                             name: doc.name,
//                             date: doc.time || doc.date || '',
//                             ...doc
//                         }));
//                     } else if (Array.isArray(rawDocs)) {
//                         docsList = rawDocs;
//                     }
//
//                     if (docsList && docsList.length > 0) {
//                         setChecked(true);
//                         setDocumentsForSign(docsList);
//                         setModalOpen(false);
//                         sendLog(serverApi, title, 'Список документов получен успешно.', 'getDocumentList', false, response);
//                     } else {
//                         navigate("/signed");
//                     }
//
//                 } else {
//                     if (response?.data?.error?.length === 0) {
//                         setError(['Ошибка получения списка документов', 'Свяжитесь с Вашим оператором']);
//                     } else {
//                         setError(response.data.error);
//                     }
//                     setChecked(false);
//                     setErrorSuccess(true);
//                     setModalOpen(false);
//                     sendLog(serverApi, title, 'Ошибка в ответе сервера', 'getDocumentList', true, response);
//                 }
//             } else {
//                 setChecked(false);
//                 setError(['Ошибка получения документов', 'Попробуйте снова']);
//                 setErrorSuccess(true);
//                 setModalOpen(false);
//                 sendLog(serverApi, title, 'Неизвестный статус ответа', 'getDocumentList', true, response);
//             }
//         }).catch((error) => {
//             setChecked(false);
//             setModalOpen(false);
//             setError(["Не удалось загрузить документы", "Попробуйте снова"]);
//             setErrorSuccess(true);
//             sendLog(serverApi, title, 'Сетевая ошибка при получении документов.', 'getDocumentList', true, error);
//             navigate("/");
//         });
//     }, [navigate, serverApi, title]);
//
//     useEffect(() => {
//         if (timer) {
//             const timerId = setInterval(() => {
//                 setTimeLeft(prevTime => prevTime > 0 ? prevTime - 1 : 0);
//             }, 1000);
//             return () => clearInterval(timerId);
//         }
//     }, [timer, timeLeft]);
//
//     useEffect(() => {
//         localStorage.setItem("doc", JSON.stringify(previewImagesState));
//     }, [previewImagesState]);
//
//     return (
//         <>
//             <div id="doc-page">
//                 <div className="fixed-top mx-auto">
//                     <div className={`${opacity} d-flex align-items-center justify-content-between background_white`}>
//                         <h1 className="header-title color_night_blue weight600_project size20_project">
//                             {userName}
//                         </h1>
//                         <img src="./icons/gos.png" className="logo-gos" alt="gos"/>
//                     </div>
//                 </div>
//                 <div className="doc-block margin100_top">
//                     {documentsForSign.length > 0 ?
//                         <div className="doc-subtitle-block d-flex justify-content-between">
//                             <p className="doc-subtitle text-start color_steel_grey weight600_project size14_project">
//                                 Ожидают вашей подписи
//                             </p>
//                             <p className="doc-subtitle text-start color_steel_grey weight600_project size14_project">
//                                 {documentsForSign.length}
//                             </p>
//                         </div> : ''
//                     }
//                     {warning?.bool &&
//                         <div className={'text-center mb-3'}>
//                             {Array.isArray(warning?.data) ?
//                                 warning?.data.map((item, index) => (
//                                     <p className={'mb-1 errWarningTextDoc'} key={item + index}>{item}</p>
//                                 )) :
//                                 (typeof warning?.data === 'string' ?
//                                     <p className={'mb-1 errWarningTextDoc'}>{warning?.data}</p> : '')
//                             }
//                         </div>
//                     }
//                     {errorSuccess &&
//                         <div className={'text-center'}>
//                             {error?.map((e, idx) => (
//                                 <p className={'mb-1 errWarningTextDoc'} key={idx}>{e}</p>
//                             ))}
//                         </div>
//                     }
//                     <div className="all-doc">
//                         {documentsForSign && Array.isArray(documentsForSign) && documentsForSign.map((e) => (
//                             <div key={e.upload_id} onClick={() => navigate(`/doc/${e.upload_id}`, {state: {name: e.name}})} style={{cursor: 'pointer'}}>
//                                 <div className="doc-item d-flex justify-content-between align-items-center">
//                                     <div>
//                                         <div className="doc-name size16_project weight400_project color_night_blue">
//                                             {e.name}
//                                         </div>
//                                         <div className="doc-date size14_project weight400_project color_steel_grey">
//                                             {e.date}
//                                         </div>
//                                     </div>
//                                     <div className={'width24px height24px'}>
//                                         <img src="./icons/Arrow.svg" className={'width20px height20px'} alt="arrow"/>
//                                     </div>
//                                 </div>
//                                 <hr className={'m-0'}/>
//                             </div>
//                         ))}
//                     </div>
//                     {checked && //doc-check
//                         <div className="d-flex">
//                             <CheckBox label="Я проверил подписываемые документы и подтверждаю ознакомление"
//                                       checked={isChecked} onChange={handleCheckboxChange}/>
//                         </div>
//                     }
//                     <div className="d-flex justify-content-center widthI">
//                         {documentsForSign.length > 0 &&
//                             <>
//                                 {timer ?
//                                     <button className="doc-btn width90 border-0 weight600_project size14_project color_dark_grey background_translucent_turquoise cursor_not_allowed" disabled>
//                                         Повторно запросить смс можно через {timeLeft.toString().padStart(2, '0')}
//                                     </button> :
//                                     <button className={`doc-btn width90 border-0 weight600_project size14_project cursor color_white background_turquoise
//                                     ${isDisabled ? 'background_translucent_turquoise color_dark_grey cursor_not_allowed' : 'background_bondi color_white cursor'}`}
//                                         onClick={handleContinueClick} disabled={!isChecked}>
//                                         Продолжить
//                                     </button>
//                                 }
//                             </>
//                         }
//                         <MyModal click={click} show={isModalOpen} onHide={() => setIsModalOpen(false)} backdrop="static"
//                             keyboard={false} title={title}/>
//                     </div>
//                 </div>
//             </div>
//
//             <Modal show={modalOpen} onHide={() => setModalOpen(false)} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
//                 <Modal.Title id={"contained-modal-title-vcenter"}>
//                     <h4 className={'color_white'}>Загрузка</h4>
//                 </Modal.Title>
//                 <Modal.Body>
//                     <div className={"d-flex align-items-center justify-content-around"}>
//                         <img className={"objRotate mr-5 loading"} id={"balance-loading"} src={refreshIcon} alt={"refreshIcon"} width={"50px"}/>
//                         <h5 className={"loader-text"}>Пожалуйста, подождите</h5>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer></Modal.Footer>
//             </Modal>
//
//             <Modal show={disDataModal} onHide={() => setDisDataModal(false)} size="lg" aria-labelledby={"contained-modal-title-vcenter"} centered>
//                 <Modal.Title id={"contained-modal-title-vcenter"} className={"centerDiv mt-3"}>
//                     <h4>Внимание!</h4>
//                 </Modal.Title>
//                 <Modal.Body>
//                     <div className={"d-flex align-items-center justify-content-around flex-column mt-1"}>
//                         <div className={"loader-text"}>Не удалось получить данные</div>
//                         {disData.map((item, index) => (
//                             <li className={"loader-text mt-1"} key={`loader-${index}`}>
//                                 {item}
//                             </li>
//                         ))}
//                         <div className={"disData-foot text-center weight600_project"}>{disDataReason}</div>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button className={"disDataBtn d-flex m-auto"} onClick={() => disDataClick(disDataAction)}>
//                         Продолжить
//                     </Button>
//                 </Modal.Footer>
//             </Modal>
//         </>
//     );
// };

import {handleContinueClick} from "../functions/documentsPage/HandleContinueClick";
import React, {useEffect, useState, useRef, useMemo} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import EmailCheckbox from "../Components/EmailCheckbox";
import {sendLog} from "../functions/common/SendLog";
import CheckBox from "../Components/CheckBox";
import MyModal from "../Components/MyModal";
import {ServerApi} from "../api/ServerApi";

//Стили
import "./style/documents.css";
import "./style/palette.css";
import "./style/common.css";

//Страница №4
//Список документов для предварительного просмотра. Модальное окно для кода подтверждения.
export default function DocumentsPage() {
    // const [warning, setWarning] = useState({data: '', bool: false});
    const [documentsForSign, setDocumentsForSign] = useState([]);
    const [previewImagesState, setPreviewState] = useState([]);
    const [errorSuccess, setErrorSuccess] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [emailForSend, setEmailForSend] = useState('');
    const [isDisabled, setIsDisabled] = useState(true);
    const [isChecked, setIsChecked] = useState(false);
    const [opacity, setOpacity] = useState('header');
    const [checked, setChecked] = useState(false);
    const [userName, setUserName] = useState("");
    const [timeLeft, setTimeLeft] = useState(60);
    const [timer, setTimer] = useState(false);
    const [error, setError] = useState([]);

    const hasFetched = useRef(false);
    const navigate = useNavigate();
    const location = useLocation();

    const title = 'Страница 4. Список документов для предварительного просмотра.';
    const serverApi = useMemo(() => new ServerApi(), []);

    const handleCheckboxChange = () => {
        setIsChecked((prevState) => !prevState);
        setIsDisabled(!isDisabled);
    };

    const click = () => {
        setIsModalOpen(false);
        setTimer(true);
        setTimeLeft(60);
    };

    useEffect(() => {
        if (location.state?.errorCode === 'wrong_code') {
            setError(['Неверный код подтверждения', 'Попробуйте снова']);
            setErrorSuccess(true);
        } else if (location.state?.errorCode === 'network_error') {
            setError(['Ошибка соединения', 'Проверьте интернет и попробуйте снова']);
            setErrorSuccess(true);
        }
        if (location.state) {
            window.history.replaceState({}, document.title);
        }
    }, [location]);

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;

        const docSessionCode = localStorage.getItem("doc_session_code");
        const appDebag = localStorage.getItem("app_debag");
        setOpacity('header2');

        serverApi.getDocumentList(docSessionCode, appDebag).then((response) => {
            if (response.status === 500) {
                setChecked(false);
                setError(['Сервис временно не доступен']);
                setErrorSuccess(true);
                sendLog(serverApi, title, 'Сервис временно не доступен', 'getDocumentList', true, response);

            } else if (response.status === 501) {
                setChecked(false);
                setError(['Нет документов на подпись', 'Свяжитесь с Вашим оператором']);
                setErrorSuccess(true);
                sendLog(serverApi, title, 'Нет документов на подпись', 'getDocumentList', true, response);

            } else if (response.status === 200) {
                if (response?.data?.success) {
                    const fio = response.data.username
                    setUserName(fio);
                    localStorage.setItem('username', fio);

                    const rawDocs = response.data.data;
                    let docsList = [];

                    if (rawDocs && typeof rawDocs === 'object' && !Array.isArray(rawDocs)) {
                        docsList = Object.entries(rawDocs).map(([upload_id, doc]) => ({
                            upload_id,
                            name: doc.name,
                            date: doc.time || doc.date || '',
                            ...doc
                        }));
                    } else if (Array.isArray(rawDocs)) {
                        docsList = rawDocs;
                    }

                    if (docsList && docsList.length > 0) {
                        setChecked(true);
                        setDocumentsForSign(docsList);
                        sendLog(serverApi, title, 'Список документов получен успешно.', 'getDocumentList', false, response);
                    } else {
                        navigate("/signed");
                    }

                } else {
                    if (response?.data?.error?.length === 0) {
                        setError(['Ошибка получения списка документов', 'Свяжитесь с Вашим оператором']);
                    } else {
                        setError(response.data.error);
                    }
                    setChecked(false);
                    setErrorSuccess(true);
                    sendLog(serverApi, title, 'Ошибка в ответе сервера', 'getDocumentList', true, response);
                }
            } else {
                setChecked(false);
                setError(['Ошибка получения документов', 'Попробуйте снова']);
                setErrorSuccess(true);
                sendLog(serverApi, title, 'Неизвестный статус ответа', 'getDocumentList', true, response);
            }
        }).catch((error) => {
            setChecked(false);
            setError(["Не удалось загрузить документы", "Попробуйте снова"]);
            setErrorSuccess(true);
            sendLog(serverApi, title, 'Сетевая ошибка при получении документов.', 'getDocumentList', true, error);
            navigate("/");
        });
    }, [navigate, serverApi, title]);

    useEffect(() => {
        if (timer) {
            const timerId = setInterval(() => {
                setTimeLeft(prevTime => prevTime > 0 ? prevTime - 1 : 0);
            }, 1000);
            return () => clearInterval(timerId);
        }
    }, [timer, timeLeft]);

    useEffect(() => {
        localStorage.setItem("doc", JSON.stringify(previewImagesState));
    }, [previewImagesState]);

    return (
        <>
            <div id="doc-page" className={'padding100_top padding100_bottom flex-column height100vh h-auto'}>
                <div className="fixed-top mx-auto">
                    <div
                        className={`${opacity} d-flex align-items-center justify-content-between background_white shadow_pastel_grey`}>
                        <h1 className="header-title color_night_blue weight600_project size20_project">
                            {userName}
                        </h1>
                        <img src="./icons/gos.png" className="logo-gos" alt="gos"/>
                    </div>
                </div>
                <div className="width90 mx-auto my-auto">
                    {documentsForSign.length > 0 ?
                        <div className="doc-subtitle-block px-2 d-flex justify-content-between">
                            <p className="doc-subtitle text-start color_steel_grey weight600_project size14_project">
                                Ожидают вашей подписи
                            </p>
                            <p className="doc-subtitle text-start color_steel_grey weight600_project size14_project">
                                {documentsForSign.length}
                            </p>
                        </div> : ''
                    }
                    {/*{warning?.bool &&*/}
                    {/*    <div className={'text-center mb-3'}>*/}
                    {/*        {Array.isArray(warning?.data) ?*/}
                    {/*            warning?.data.map((item, index) => (*/}
                    {/*                <p className={'mb-1 errWarningTextDoc color_night_blue'}*/}
                    {/*                   key={item + index}>{item}</p>*/}
                    {/*            )) :*/}
                    {/*            (typeof warning?.data === 'string' ?*/}
                    {/*                <p className={'mb-1 errWarningTextDoc color_night_blue'}>{warning?.data}</p> : '')*/}
                    {/*        }*/}
                    {/*    </div>*/}
                    {/*}*/}
                    {errorSuccess &&
                        <div className={'text-center'}>
                            {error?.map((e, idx) => (
                                <p className={'mb-1 errWarningTextDoc color_night_blue'} key={idx}>{e}</p>
                            ))}
                        </div>
                    }
                    <div className="all-doc">
                        {documentsForSign && Array.isArray(documentsForSign) && documentsForSign.map((e) => (
                            <div key={e.upload_id}
                                 onClick={() => navigate(`/doc/${e.upload_id}`, {state: {name: e.name}})}
                                 className={'cursor border_bottom_grey_alpha_25'}>
                                <div className="doc-item d-flex justify-content-between align-items-center ps-2 py-2">
                                    <div>
                                        <div className="doc-name size16_project weight400_project color_night_blue">
                                            {e.name}
                                        </div>
                                        <div className="doc-date size14_project weight400_project color_steel_grey">
                                            {e.date}
                                        </div>
                                    </div>
                                    <div className={'width24px height24px'}>
                                        <img src="./icons/Arrow.svg" className={'width20px height20px'} alt="arrow"/>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="d-flex">
                        <EmailCheckbox label={'Отправить на электронную почту'} onEmailChange={setEmailForSend}/>
                    </div>
                    {checked &&
                        <div className="d-flex">
                            <CheckBox label="Я проверил подписываемые документы и подтверждаю ознакомление"
                                      checked={isChecked} onChange={handleCheckboxChange}/>
                        </div>
                    }
                </div>

                {documentsForSign.length > 0 && (
                    <div className="fixed-bottom mx-auto d-flex justify-content-center width90 bg-white margin40_bottom" style={{borderRadius: '12px'}}>
                        {timer ?
                            <button className="doc-btn w-100 border-0 weight600_project size14_project color_dark_grey background_translucent_turquoise cursor_not_allowed" disabled>
                                Повторно запросить смс можно через {timeLeft.toString().padStart(2, '0')}
                            </button> :
                            <button className={`doc-btn w-100 border-0 weight600_project size14_project cursor color_white background_turquoise 
                            ${isDisabled ? 'background_translucent_turquoise color_dark_grey cursor_not_allowed' : 'background_bondi'}`}
                                    onClick={() => handleContinueClick(serverApi, title, setIsModalOpen, setError, setErrorSuccess, emailForSend)}
                                    disabled={!isChecked}>
                                Продолжить
                            </button>
                        }
                    </div>
                )}
                <MyModal click={click} show={isModalOpen} onHide={() => setIsModalOpen(false)} backdrop="static"
                         keyboard={false} title={title}/>
            </div>
        </>
    );
};
